export default __webpack_public_path__ + "static/media/caretGray.bd4adccb.svg";